import { render, staticRenderFns } from "./VueKeyboard.vue?vue&type=template&id=67944791&"
import script from "./VueKeyboard.vue?vue&type=script&lang=js&"
export * from "./VueKeyboard.vue?vue&type=script&lang=js&"
import style0 from "vue-touch-keyboard/dist/vue-touch-keyboard.css?vue&type=style&index=0&lang=css&"
import style1 from "./VueKeyboard.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports